<ng-container *transloco="let t; prefix: 'home.devmode'">
  <div class="text">
    <h2>{{ t('title') }}</h2>
    <p>{{ t('description') }}</p>
  </div>
  <div class="actions">
    <a class="btn-flat primary" href="https://kampoy.com">{{ t('official') }}</a>
    <button class="btn" (click)="close.emit()">{{ t('stay') }}</button>
  </div>
</ng-container>
